<template>
  <div class="table-responsive">
    <table :class="getClasses" v-bind="$attrs">
      <slot/>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BaseTable',

  props: {
    bordered: Boolean,
    borderless: Boolean,
    dark: Boolean,
    hover: { default: true, type: Boolean },
    small: Boolean,
    striped: { default: true, type: Boolean }
  },

  computed: {
    getClasses () {
      return {
        'table': true,
        'table-bordered': this.bordered,
        'table-borderless': this.borderless,
        'table-dark': this.dark,
        'table-hover': this.hover,
        'table-sm': this.small,
        'table-striped': this.striped
      }
    }
  }
}
</script>
